import QrScanner from './QrScanner';

export default QrScanner;
